import { render } from "./PostListView.vue?vue&type=template&id=770466ae"
import script from "./PostListView.vue?vue&type=script&lang=js"
export * from "./PostListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__